import { render, staticRenderFns } from "./OrdersSchedule.vue?vue&type=template&id=1e926d23"
import script from "./OrdersSchedule.vue?vue&type=script&lang=js"
export * from "./OrdersSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports